import { AqElement, qs } from '@aq/core';

/* Loads a section's content when it scrolls into view, from a URL that returns the section
   (used with Shopify's product recommendations endpoint). Swaps in the same element from the response. */
class AqLazySection extends AqElement {
  init() {
    if (this.dataset.loaded === 'true') return;
    if (!('IntersectionObserver' in window)) {
      this.#load();
      return;
    }
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        this.observer.disconnect();
        this.#load();
      },
      { rootMargin: '300px' },
    );
    this.observer.observe(this);
  }

  destroy() {
    this.observer?.disconnect();
  }

  async #load() {
    try {
      const response = await fetch(this.dataset.url);
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = qs('aq-lazy-section', doc);
      if (!next || !next.innerHTML.trim()) return;
      this.innerHTML = next.innerHTML;
      this.dataset.loaded = 'true';
      this.closest('.shopify-section')?.removeAttribute('hidden');
    } catch {
      /* the section stays empty: recommendations are an enhancement */
    }
  }
}

if (!customElements.get('aq-lazy-section')) customElements.define('aq-lazy-section', AqLazySection);
